export default __webpack_public_path__ + "static/media/music.b26de9a9.png";